import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcClapperboard, FcCompactCamera } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { extractDate } from "../../../Components/Functions/date.fun";

const ViewReelShort = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/reelshort/view/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting podcasts!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  const linkifyText = (text) => {
    if (!text) return "N/A";

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCompactCamera className="fs-2 me-1" />
                  Reel / Short
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Reel / Short</h2>
            </div>

            <div className="card-body">
              {!data ? (
                <div className="text-center text-muted">No data found</div>
              ) : (
                <>
                  <h3> Reel / Short</h3>
                  <hr className=""></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reel / Short Branding Assets
                    </label>
                    <div className="w-100 col">
                      {data?.shortBrandingAss || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Reel Type</label>
                    <div className="w-100 col">{data?.reelType || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Raw Source</label>
                    <div className="w-100 col">{linkifyText(data?.rawSource || "N/A")}</div>
                  </div>

                  <hr className=""></hr>
                  <h3> Edit Reel / Shorts</h3>
                  <hr className=""></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Editor Name</label>
                    <div className="w-100 col">
                      {data?.reelShortEditor || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Deadline
                    </label>
                    <div className="w-100 col">
                      {data?.taskdedline || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reel / Short Thumbnail
                    </label>
                    <div className="w-100 col">
                      {data?.shortThumbnail ? (
                        <LazyImageComponent
                          width="40%"
                          src={data?.shortThumbnail}
                          alt="Short Thumbnail"
                          // className="rounded"
                        />
                      ) : (
                        "Short Thumbnaile Not Available"
                      )}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reel First Draft File Path
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.reelFirstPath || "N/A")}
                    </div>
                  </div>

                  <hr className=""></hr>
                  <h3> Final Reels / Shorts</h3>
                  <hr className=""></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reel / Short Final Footage Path
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.shortDriveLink) || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reel Publish Date
                    </label>
                    <div className="w-100 col">
                      {data?.publishDate || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reel Publish Time
                    </label>
                    <div className="w-100 col">
                      {data?.publishTime || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reel Short / Title
                    </label>
                    <div className="w-100 col">{data?.shortTitle || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Reel / Short Description{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.shortDescription) || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Mark as Published (Upload proof)
                    </label>
                    <div className="w-100 col">
                      {data?.markAsPublished ? (
                        <LazyImageComponent
                          width="40%"
                          src={data?.markAsPublished}
                          alt="Mark as published"
                          // className="rounded"
                        />
                      ) : (
                        "Mark as published"
                      )}
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <SimpleButton
                        buttonText="Edit Reel / Short"
                        href={`/edit-reel-short/${id}`}
                      />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewReelShort;
